import useUserStore from '@/stores/userStore';

// The merchant's carrier-selection MODE, as the backend sees it.
//
// ⚠️ NOT a UI switch any more. No merchant sees a carrier, whatever their mode
// (owner 2026-10-28: "we don't show carriers in dashboard, never ever"), so
// every screen renders the service-only UI for everyone. Use this only where
// the BACKEND answers differently by mode (e.g. carrier-proof 403s Select).
//
// The mode rides on GET /v1/user (`object.setting.carrier_selection_mode`),
// which App.tsx already pushes into userStore — same synchronous seam
// usePermission uses, no extra request.
//
// Anything other than the literal 'boxy_select' — including the field being
// absent, which is what every backend that has not shipped WP-A sends — is
// rate-shopper, i.e. today's system.
const useBoxySelect = (): boolean =>
  useUserStore((state) => state.user?.setting?.carrier_selection_mode === 'boxy_select');

export default useBoxySelect;
